import { createSelector } from '@reduxjs/toolkit';
import { selfSelector } from '../self';

const pixelsErrorSelector = createSelector(selfSelector, (pixels) => pixels.error);

export default pixelsErrorSelector;
